module.exports = __webpack_public_path__ + "img/IMG_3496.083ea12d.jpg";